import { createAction } from 'typesafe-actions';
import { EmptyPayload, MainResourceHandler } from './types';

export function createClearErrorAndPatchDataAction<
  TItemKey,
  TItemSummary extends TItemKey,
  TItemBody extends TItemKey,
>(displayName: string) {
  const clearErrorAndPatchData = createAction(
    `@${displayName}/clearErrorAndPatchData`,
  )<EmptyPayload>();

  const clearErrorAndPatchDataHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof clearErrorAndPatchData
  > = ({ error, patchData, ...state }) => {
    return state;
  };

  return {
    clearErrorAndPatchData,
    clearErrorAndPatchDataHandler,
  };
}
